export default "__VITE_ASSET__13743aa4__"